import { Component, Input } from '@angular/core';
import { GenericValidationError } from '../models/generic-bulk-upsert.model';

@Component({
  selector: 'generic-validation-errors-table',
  templateUrl: './validation-errors-table.component.html'
})
export class GenericValidationErrorsTableComponent {
  @Input() errors: GenericValidationError[] = [];
  @Input() fields: import('../models/generic-bulk-upsert.model').GenericBulkUpsertField[] = [];

  // Pagination
  currentPage = 1;
  pageSize = 15;

  get pagedErrors(): GenericValidationError[] {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.errors.slice(start, end);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = 1;
  }

  getFieldLabel(fieldKey: string): string {
    const field = this.fields.find(f => f.key === fieldKey);
    return field ? field.label : fieldKey;
  }
}
